import { createContext, useContext, useState } from "react";

const DropdownContext = createContext();
function DropdownProvider({ children }) {
  const [show, setShow] = useState(false);
  const [option, setOption] = useState("");
  const toggle = () => {
    setShow(!show);
  };
  const values = { show, setShow, toggle, option, setOption };
  return (
    <DropdownContext.Provider value={values}>
      {children}
    </DropdownContext.Provider>
  );
}
function useDropdown() {
  const context = useContext(DropdownContext);
  if (typeof context === "undefined")
    throw new Error("useDropdown must be used within DropdownProvider");
  return context;
}
export { useDropdown, DropdownProvider };
